import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createCustomerRegion,
  createCustomerSubRegion,
  deleteCustomerRegion,
  deleteCustomerSubRegion,
  fetchCustomerRegion,
  fetchCustomerSubRegion,
  updateCustomerRegion,
  updateCustomerSubRegion,
} from "../../../services/customerRegionService";

export const fetchCustomerRegionAsync = createAsyncThunk(
  "customerregion/fetchCustomerregion",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerRegion();
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch CustomerType data"
      );
    }
  }
);

export const fetchCustomerSubRegionAsync = createAsyncThunk(
  "customersubregion/fetchCustomersubregion",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerSubRegion();
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch CustomerType data"
      );
    }
  }
);

export const createCustomerRegionAsync = createAsyncThunk(
  "customerregion/createcustomerregion",
  async (customerregiondata, { rejectWithValue }) => {
    try {
      const response = await createCustomerRegion(customerregiondata);
      return response;
    } catch (error) {
      console.error("Error creating role:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const createCustomerSubRegionAsync = createAsyncThunk(
  "customerregion/createcustomersubregion",
  async (customerSubregiondata, { rejectWithValue }) => {
    try {
      const response = await createCustomerSubRegion(customerSubregiondata);
      return response;
    } catch (error) {
      console.error("Error creating role:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const deleteCustomerRegionAsync = createAsyncThunk(
  "customerregion/deleteCustomerRegion",
  async (id, { rejectWithValue }) => {
    try {
      await deleteCustomerRegion(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteCustomerSubRegionAsync = createAsyncThunk(
  "customersubregion/deleteCustomerSubRegion",
  async (id, { rejectWithValue }) => {
    try {
      await deleteCustomerSubRegion(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateCustomerRegionAsync = createAsyncThunk(
  "customerregion/updateCustomerRegion",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await updateCustomerRegion(id, data);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update Customer Region"
      );
    }
  }
);

export const updateCustomerSubRegionAsync = createAsyncThunk(
  "customersubregion/updateCustomerSubRegion",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await updateCustomerSubRegion(id, data);
      return response?.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update Customer Region"
      );
    }
  }
);

const customerRegionSlice = createSlice({
  name: "CustomerRegion",
  initialState: {
    CustomerRegionData: [],
    customerSubregiondata: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerRegionAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerRegionAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.CustomerRegionData = action.payload;
      })
      .addCase(fetchCustomerRegionAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCustomerRegionAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCustomerRegionAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.CustomerRegionData.push(action.payload);
      })
      .addCase(createCustomerRegionAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createCustomerSubRegionAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCustomerSubRegionAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.customerSubregiondata.push(action.payload);
      })
      .addCase(createCustomerSubRegionAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteCustomerRegionAsync.fulfilled, (state, action) => {
        state.CustomerRegionData = state.CustomerRegionData.filter(
          (region) => region.id !== action.payload
        );
      })
      .addCase(deleteCustomerRegionAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(deleteCustomerSubRegionAsync.fulfilled, (state, action) => {
        state.customerSubregiondata = state.customerSubregiondata.filter(
          (region) => region.id !== action.payload
        );
      })
      .addCase(deleteCustomerSubRegionAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateCustomerRegionAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCustomerRegionAsync.fulfilled, (state, action) => {
        const index = state.CustomerRegionData.findIndex(
          (region) => region.id === action.payload.id
        );
        if (index !== -1) {
          state.CustomerRegionData[index] = action.payload;
        }
        state.loading = false;
      })
      .addCase(updateCustomerRegionAsync.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(updateCustomerSubRegionAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCustomerSubRegionAsync.fulfilled, (state, action) => {
        const index = state.customerSubregiondata.findIndex(
          (region) => region.id === action.payload.id
        );
        if (index !== -1) {
          state.customerSubregiondata[index] = action.payload;
        }
        state.loading = false;
      })
      .addCase(updateCustomerSubRegionAsync.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })

      .addCase(fetchCustomerSubRegionAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerSubRegionAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.customerSubregiondata = action.payload || [];
      })
      .addCase(fetchCustomerSubRegionAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default customerRegionSlice.reducer;
